/**************************************************************************
 * Created on Tue Aug 27 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/
import React from "react";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";


const RequireAuth = () =>
{
    const { auth } = useAuth();
    const location = useLocation();
    const [ searchParams ] = useSearchParams();
    const guestToken = searchParams.get('token');

    // useEffect(() =>
    // {
    //     if (auth.token)
    //     {

    //     }

    // }, [ auth.token ])

    return (
        auth.isAuthenticated
            ? <Outlet />
            : guestToken
                ? <Navigate to='/guest' state={ { token: guestToken } } replace />
                : <Navigate to='/prelogin' state={ { from: location } } replace />

    );
};

export default RequireAuth;